import {HIDE_SQFT_TOOLTIP, SHOW_SQFT_TOOLTIP} from "../../actions/actionTypes";

const initialState = {
  isVisible: false,
  title: '',
  description: '',
  icon: null,
  position: 'right',
  targetRect: null
};

const sqftTooltipReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SQFT_TOOLTIP:
      return {
        ...state,
        isVisible: true,
        title: action.payload.title,
        description: action.payload.description,
        icon: action.payload.icon,
        position: action.payload.position,
        targetRect: action.payload.targetRect
      };

    case HIDE_SQFT_TOOLTIP:
      return {
        ...state,
        isVisible: false
      };

    default:
      return state;
  }
};

export default sqftTooltipReducer;
